'use strict';

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _keys = require('./lib/keys');

var _keys2 = _interopRequireDefault(_keys);

var _kalimba = require('./lib/kalimba');

var _kalimba2 = _interopRequireDefault(_kalimba);

var _colundi = require('./lib/colundi');

var _colundi2 = _interopRequireDefault(_colundi);

var _util = require('./lib/util');

var _honeycombGrid = require('honeycomb-grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gridSize = _util.browser.isMobile ? 25 : 50;
var hexagon = polygon(6, gridSize);

var hertz_el = document.querySelector('#hertz');

var grid = (0, _honeycombGrid.Grid)({
  size: gridSize
});

var Hex = (0, _honeycombGrid.HexFactory)({
  size: gridSize,
  template: function template(hex) {
    return '\n      <svg class=\'hex\'>\n        <polygon points=\'' + hexagon.pointString + '\' />\n      </svg>\n    ';
  }
});

var container = document.querySelector('#container');
var origin = {
  x: container.offsetWidth / 2 - hexagon.width / 2,
  y: container.offsetHeight / 2 - hexagon.height / 2
};
var view = _honeycombGrid.Views.DOM({
  container: container,
  origin: origin
});

var last = null,
    dragging = false;
var hexes = void 0,
    els = [],
    order = [];

(0, _util.requestAudioContext)(init);

function init() {
  if (_util.browser.isMobile) {
    document.addEventListener('touchstart', touch(down));
    document.addEventListener('touchmove', touch(move, true));
    document.addEventListener('touchend', touch(up));
  } else {
    document.addEventListener('mousedown', down);
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
  }
  document.querySelector('#frequency').addEventListener('click', sortByFrequency);
  document.querySelector('#color').addEventListener('click', sortByColor);
  document.querySelector('#brightness').addEventListener('click', sortByBrightness);
  build(_colundi2.default.list);
  _keys2.default.listen(function (index) {
    index += 20;
    var freq = _colundi2.default.index(index);
    _kalimba2.default.play(freq);
  });
}
function sortByBrightness() {
  els.sort(function (a, b) {
    return a.lum > b.lum ? -1 : a.lum == b.lum ? 0 : 1;
  }).map(resort);
}
function sortByColor() {
  els.sort(function (a, b) {
    return a.hue < b.hue ? -1 : a.hue == b.hue ? 0 : 1;
  }).map(resort);
}
function sortByFrequency() {
  els.sort(function (a, b) {
    return a.freq > b.freq ? -1 : a.freq == b.freq ? 0 : 1;
  }).map(resort);
}
function resort(tuple, i) {
  var position = order[i];
  hexes[position.id] = tuple;
  tuple.el.style.top = position.top;
  tuple.el.style.left = position.left;
}
function build(list) {
  container.innerHTML = '';
  var perimeter = [Hex(0, 0, 0)];
  hexes = {};

  var _loop = function _loop(_i, len) {
    var hex = perimeter.shift();
    var id = hexToString(hex);
    if (hexes[id]) return 'continue';
    var pair = list[len - _i - 1];
    var neighbors = [0, 1, 2, 3, 4, 5].map(function (j) {
      return Hex.neighbor(hex, j);
    });
    perimeter = perimeter.concat(neighbors);
    view.renderHexes([hex]);
    var el = container.lastChild;
    el.querySelector('polygon').setAttribute('fill', pair.color);
    var hsl = rgbStringToHSL(pair.color);
    var tuple = { el: el, freq: pair.freq, hue: (hsl[0] + 0.2) % 1, lum: hsl[2] };
    hexes[id] = tuple;
    els.push(tuple);
    order.push({ id: id, top: el.style.top, left: el.style.left });
    _i++;
    i = _i;
  };

  for (var i = 0, len = list.length; i < len;) {
    var _ret = _loop(i, len);

    if (_ret === 'continue') continue;
  }
}
function down(e) {
  dragging = true;
  var hex = grid.pointToHex({
    x: e.pageX - origin.x - hexagon.width / 2,
    y: e.pageY - origin.y - hexagon.height / 2
  });
  var pair = find(hex);
  if (!pair) return;
  pair.el.style.opacity = 0.5;
  hertz_el.innerHTML = pair.freq;
  _kalimba2.default.play(pair.freq);
  last = pair;
}
function move(e) {
  if (!dragging) return;
  var hex = grid.pointToHex({
    x: e.pageX - origin.x - hexagon.width / 2,
    y: e.pageY - origin.y - hexagon.height / 2
  });
  var pair = find(hex);
  if (last === pair) return;
  if (last) last.el.style.opacity = 1;
  if (!pair) return;
  pair.el.style.opacity = 0.5;
  hertz_el.innerHTML = pair.freq;
  _kalimba2.default.play(pair.freq);
  last = pair;
}
function up(e) {
  if (last) last.el.style.opacity = 1;
  last = null;
  hertz_el.innerHTML = '';
  dragging = false;
}
function find(hex) {
  var id = hexToString(hex);
  if (id in hexes) return hexes[id];
  return null;
}
function touch(fn, shouldPreventDefault) {
  return function (e) {
    shouldPreventDefault && e.preventDefault();
    fn(e.touches[0]);
  };
}
function polygon(n, side) {
  var points = [];
  var xs = [],
      ys = [];
  var min_x = Infinity,
      max_x = -Infinity;
  var min_y = Infinity,
      max_y = -Infinity;
  var x = void 0,
      y = void 0;
  for (var _i2 = 0; _i2 < n; _i2++) {
    x = side * Math.cos(Math.PI / n * (1 + 2 * _i2));
    y = side * Math.sin(Math.PI / n * (1 + 2 * _i2));
    min_x = Math.min(min_x, x);
    max_x = Math.max(max_x, x);
    min_y = Math.min(min_y, y);
    max_y = Math.max(max_y, y);
    xs.push(x);
    ys.push(y);
  }
  for (var _i3 = 0; _i3 < n; _i3++) {
    points.push(xs[_i3] - min_x, ys[_i3] - min_y);
  }
  return {
    points: points,
    pointString: points.map(function (p) {
      return p.toFixed(3);
    }).join(' '),
    width: max_x - min_x,
    height: max_y - min_y
  };
}
function hexToString(hex) {
  return [hex.x, hex.y, hex.z].join('_');
}
function rgbStringToHSL(s) {
  var RGB = s.replace('rgb(', '').replace(')', '').split(', ').map(function (a) {
    return parseInt(a);
  });
  var R = RGB[0];
  var G = RGB[1];
  var B = RGB[2];
  var var_R = R / 255; //RGB from 0 to 255
  var var_G = G / 255;
  var var_B = B / 255;

  var var_Min = Math.min(var_R, var_G, var_B); //Min. value of RGB
  var var_Max = Math.max(var_R, var_G, var_B); //Max. value of RGB
  var del_Max = var_Max - var_Min; //Delta RGB value

  var H, S;
  var L = (var_Max + var_Min) / 2;

  if (del_Max == 0) //This is a gray, no chroma...
    {
      H = 0; //HSL results from 0 to 1
      S = 0;
    } else //Chromatic data...
    {
      if (L < 0.5) S = del_Max / (var_Max + var_Min);else S = del_Max / (2 - var_Max - var_Min);

      var del_R = ((var_Max - var_R) / 6 + del_Max / 2) / del_Max;
      var del_G = ((var_Max - var_G) / 6 + del_Max / 2) / del_Max;
      var del_B = ((var_Max - var_B) / 6 + del_Max / 2) / del_Max;

      if (var_R == var_Max) H = del_B - del_G;else if (var_G == var_Max) H = 1 / 3 + del_R - del_B;else if (var_B == var_Max) H = 2 / 3 + del_G - del_R;

      if (H < 0) H += 1;
      if (H > 1) H -= 1;
    }
  return [H, S, L];
}


//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 9
// module chunks = 0